// extracted by mini-css-extract-plugin
export default {"container":"_3uRfqH0A","title":"_2xplFxZY"};